import { Col, Flex, Typography, Card, Row } from 'antd';
import styles from './Home.module.css';
import Diagram from './Diagram';
import Contacts from './Contacts';
import diagram from '../json/diagram.json';
import contacts from '../json/contacts.json';
import Title from './Title';

const { Text } = Typography;

const Home = () => {
  return (
    <>
      <div className={styles['title-container']}>
        <img src="nutriarquivo.svg" style={{ maxWidth: '50%', maxHeight: '50%' }} alt="NutriArquivo Logo" />
      </div>
      <Flex>
        <Col span={12} style={{ textAlign: 'justify', paddingRight: '40px' }}>
          <Text style={{ fontSize: '20px' }}>
            Os micronutrientes, são moléculas essenciais ao funcionamento dos organismos vivos e geralmente estão
            subdivididos em vitaminas e minerais. Apesar do prefixo “micro” a sua função e importância são muito
            grandes, devendo-se a designação apenas ao facto de serem substâncias necessárias em menores quantidades do
            que os ditos macronutrientes (hidratos de carbono, proteínas, gorduras etc.). Cada micronutriente é único e
            não pode ser substituído por nenhum outro elemento por isso deficiências de qualquer um deles pode ter
            consequências drásticas no organismo, podendo mesmo levar à morte em situações extremas.
          </Text>
        </Col>
        <Col span={12} style={{ textAlign: 'justify' }}>
          <Text style={{ fontSize: '20px' }}>
            O NutriArquivo surgiu de uma parceria entre um biólogo molecular, envolvido na área da nutrição, e
            (bio)informáticos que quiseram examinar o Arquivo.pt para perceber o que este poderia revelar sobre
            micronutrientes e a sua associação a diferentes doenças, áreas geográficas e fenómenos sociais e culturais,
            ao longo dos anos. O projecto pretende promover a curiosidade e a exploração do fascinante e complexo mundo
            da nutrição, tendo como mote que uma sociedade mais informada é uma sociedade mais consciente e saudável.
            Não se pretende substituir o aconselhamento por especialistas de saúde, mas sim ajudar as mentes mais
            curiosas a explorar o fascinante e complexo tema da nutrição.
          </Text>
        </Col>
      </Flex>
      {diagram.map((parent) => {
        return <Diagram key={parent.title} title={parent.title} nodes={parent.nodes} order={parent.order}></Diagram>;
      })}
      {contacts.map((parent) => {
        return <Contacts key={parent.title} title={parent.title} nodes={parent.nodes} order={parent.order}></Contacts>;
      })}
      <div>
        <Title label="Contactos" />
        <Flex justify="space-between" align="center">
          <div>
            <Flex>
              <img
                style={{
                  height: '2em',
                  objectFit: 'contain',
                  marginRight: '10px',
                }}
                src="images\Nutriarquivo_Contacto_Icon.png"
                alt="E-mail"
              />
              <Typography.Title level={4} style={{ margin: 0 }}>
                nutriarquivos-publico@hotmail.com
              </Typography.Title>
            </Flex>
          </div>
          <img
            src="images\BIOPOLIS_CIBIO_LOGO_BRANCO.png"
            style={{ height: '4em', objectFit: 'contain' }}
            alt="BIOPOLIS & CIBIO_LOGO_BRANCO"
          />
        </Flex>
      </div>
    </>
  );
};

export default Home;
